import React from "react";
/**
 * Render the button elements in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Button(props) {
    return React.createElement("button", { ...props });
}
//# sourceMappingURL=Button.js.map